export default {
  Tenant: 1,
  User: 2,
};
